import {Injectable, OnInit, ViewContainerRef} from '@angular/core';
import {RequestsService} from './requests.service';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {MasterItemVariantsModel} from '../DTO/masterItemVariantsModel';
import {ItemLists} from '../DTO/itemLists';
import {SalesItem} from '../DTO/SalesItem';
import {Print_report_obj} from '../DTO/Print_report_obj';
import {ToastsManager} from 'ng6-toastr';
import {ActivatedRoute, Router} from '@angular/router';

@Injectable()
export class SharedService implements OnInit {
  constructor(private requestService: RequestsService, public toastr: ToastsManager, private requestsService: RequestsService,private router: Router, public ActiveRoute: ActivatedRoute) {
    // this.toastr.setRootViewContainerRef(vcr);
    setInterval(() => {
      this.internetConnectivity = navigator.onLine;

        if (!this.internetConnectivity) {
             console.log('we are offline')
        }

      }, 1000);
  }


  //event emitter for variants in add Items
  public variantArray = new Subject<any>();
  public addVariant = new Subject<any>();
  public dining = new BehaviorSubject([]);
  public toasteNotification = new Subject<any>();
  public variantsData: MasterItemVariantsModel[] = [];
  public selectedVariantArray = [];

  public print_report_obj: Print_report_obj = new Print_report_obj();
  public print_by_inv_barcode = '';
  public after_print_redirect_to = 'sell';
/// Settings
  login_heading: string;
  login_text: string;
  currency: any;
  countries: any;
  cities: any;
  timeZone: any;
  internetConnectivity: boolean = true;


  public changeAcountSetting = new Subject<any>();
  public updateStoreSetting = new Subject<any>();
  public getOrderUpdate = new Subject<any>();
  public kitchenScreen = new Subject<any>();
  public servingNumber = new Subject<any>();

  ngOnInit() {
  }

  updateServingNumber(): Observable<any> {
    return this.servingNumber.asObservable();
  }
  getKitchenOrdersUpdate(): Observable<any> {
    return this.kitchenScreen.asObservable();
  }

  getFodiOrdersUpdate(): Observable<any> {
    return this.getOrderUpdate.asObservable();
  }

  getVariants(): Observable<any> {
    return this.variantArray.asObservable();
  }

  addVariants(): Observable<any> {
    return this.addVariant.asObservable();
  }

  accountSetting(): Observable<any> {
    return this.changeAcountSetting.asObservable();
  }

  updateStore(): Observable<any> {
    return this.updateStoreSetting.asObservable();
  }

  //upload and preview files
  detectFiles(event) {
    let imageUrl = [];
    let files = event.target.files;
    if (files) {
      for (let file of files) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          imageUrl.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    }
    return imageUrl;
  }

  //filter array by key value
  filterByKey(array, key, value) {
    return array.filter(function (e) {
      return e[key] == value;
    });
  }

  //filter array by not key value
  filterByKeyNot(array, key, value) {
    return array.filter(function (e) {
      return e[key] != value;
    });
  }
  switchStore(){
    this.router.navigate(['/switch-store']);

  }
}
